var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('span',{staticClass:"material-icons animation-spin",staticStyle:{"font-size":"70px"}},[_vm._v("\n    scatter_plot\n  ")])])
}]

export { render, staticRenderFns }